import React, {useEffect, useState} from 'react';
import { MasterDataGrid } from "@/components/";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import FollowupSubProjectPresenter from "../../../../presenters/screens/followup-subproject.presenter";
import FinancialExpectedResults from './expected-results';
import { Constants, Utilities, Enums } from '@utils';
import FinancialError from './financial-error';
import FinancialSections from './sections';

interface IFinancialDetailProps{
    status: any;
    screen?: string;
    section: string;
    projectData: any;
    saveTable?: any;
    refresh?: any;
    sectionData: any
    tableAlert?: string;
    dataColumns: any;
    initialValidate: boolean;
}

const FollowUpFinancialDetail: React.FC<IFinancialDetailProps> = ({status, screen, section, projectData, saveTable, refresh, sectionData, tableAlert, dataColumns, initialValidate} : IFinancialDetailProps) => {
    const [columns, setColumns] = useState([]);
    const [summaryData, setSummaryData] = useState([]);
    const [finResume, setFinResume] = useState<any>(null);

    const view: IFollowupSubproject = {
        state: {
            projectData,
            dataColumns,
            setFinResume,
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    useEffect(() => {
        if(sectionData?.length && section === "activity"){
            let auxData = Utilities.copyObject(sectionData)
            const newData: any[] = presenter.getTotalResults(auxData) || []
            setSummaryData(newData)
        }
    }, [sectionData, refresh]);

    useEffect(() => {
        if(dataColumns?._values?.length){
            let finColumns = presenter.getFinancialColumns(status, projectData?.year, section);
            setColumns(finColumns)
        }
    }, [dataColumns, status?.CodigoDimension, presenter.subProjectMonths, sectionData?.data, status?.EnEdicion]);

    useEffect(() => {
        if(sectionData && section === "resume") {
            let resumeData = presenter.getFinancialResume(sectionData)
            setFinResume(resumeData)
        }
    }, [sectionData, refresh]);

    const calculateTotalRow = (options: any, columns: any, idx?: number) => {
        let monthsEn = Constants.Months.English
        let auxData = (!Utilities.isNullEmptyObject(idx)) ? sectionData[idx]?.data : (summaryData?.length) ? summaryData : sectionData.data
        if (options.summaryProcess === 'start' && options.name !== "notValue") {
            if(options?.name?.includes("percent")){
                options.subTotalValue = 0;
                options.subTotalAcum = 0;
            }
            if(options?.name === "currentBudgetMod"){
                options.totalValue = 0
                for (const el of auxData) {
                    const value = (!Utilities.isNullEmptyObject(el.currentBudgetMod)) ? el.currentBudgetMod : (el.currentBudget || 0);
                    options.totalValue += value;
                }
            }else if(options?.name === "totalBudgetMod"){
                options.totalValue = 0
                for (const el of auxData) {
                    const value = (!Utilities.isNullEmptyObject(el.totalBudgetMod)) ? el.totalBudgetMod : (el.totalBudget || 0);
                    options.totalValue += value;
                }
            }else options.totalValue = 0;
        } else if (options.summaryProcess === 'calculate' && options.name !== "notValue") {
            if(options?.name === "currentBudgetMod"){
                options.totalValue = 0
                for (const el of auxData) {
                    const value = (!Utilities.isNullEmptyObject(el.currentBudgetMod)) ? el.currentBudgetMod : (el.currentBudget || 0);
                    options.totalValue += value;
                }
            }else if(options?.name === "totalBudgetMod"){
                options.totalValue = 0
                for (const el of auxData) {
                    const value = (!Utilities.isNullEmptyObject(el.totalBudgetMod)) ? el.totalBudgetMod : (el.totalBudget || 0);
                    options.totalValue += value;
                }
            }else if(options?.name?.includes("Pl accum")){
                options.totalValue = 0
                let name = options.name.replace("Pl accum", '')
                const index = monthsEn.findIndex((month: string) => month === name);
                for(let i = 0; i <= index; i++){
                    for (const el of auxData) {
                        const value = el[monthsEn[i] + 'Pl'] ? el[monthsEn[i] + 'Pl'] : 0;
                        options.totalValue += value;
                    }
                } 
            }else if(options?.name?.includes("Re accum")){
                options.totalValue = 0
                let name = options.name.replace("Re accum", '')
                const index = monthsEn.findIndex((month: string) => month === name);
                for(let i = 0; i <= index; i++){
                    for (const el of auxData) {
                        const value = el[monthsEn[i] + 'Re'] ? el[monthsEn[i] + 'Re'] : 0;
                        options.totalValue += value;
                    }
                }
            }else if(options?.name?.includes("percent")){
                options.subTotalAcum = 0
                options.subTotalValue = 0
                if(options?.name?.includes("Pl percent")){
                    let name = options.name.replace("Pl percent", '')
                    const index = monthsEn.findIndex((month: string) => month === name);
                    for(let i = 0; i <= index; i++){
                        for (const el of auxData) {
                            const value = el[monthsEn[i] + 'Pl'] ? el[monthsEn[i] + 'Pl'] : 0;
                            options.subTotalValue += value;
                        }
                    }
                }else if(options?.name?.includes("Re percent")){
                    let name = options.name.replace("Re percent", '')
                    const index = monthsEn.findIndex((month: string) => month === name);
                    for(let i = 0; i <= index; i++){
                        for (const el of auxData) {
                            const value = el[monthsEn[i] + 'Re'] ? el[monthsEn[i] + 'Re'] : 0;
                            options.subTotalValue += value;
                        }
                    }
                }else if(options?.name?.includes("currentBudget")){
                    for (const el of auxData) {
                        const value = (el.currentBudget || 0);
                        options.subTotalAcum += value;
                        options.subTotalValue += value;
                    }
                }else{
                    options.subTotalValue += options.value || 0 ;
                }

                if(!options?.name?.includes("currentBudget")){
                    for (const el of auxData) {
                        const value = (el.currentBudget || 0);
                        options.subTotalAcum += value;
                    }
                }
                options.totalValue = options.subTotalAcum !== 0 ? options.subTotalValue / options.subTotalAcum : 0;
            }else{
                options.totalValue += options.value
            }
        }
    }

    let resumeTourData = null
    if(section === "resume" && presenter.stepTourFin > 1) resumeTourData = presenter.getTourData(2, Enums.FollowupDimensions.financial)

    return (
        <>
        { ((sectionData && columns?.length && section !== "resume") || (section === "resume" && finResume))
            ?
                (section !== "activity")
                ?
                    (section === "resume")
                    ?
                        <div id='FinancialTourStep2'>
                            <FinancialError 
                                followupLabels={presenter.followupLabels}
                                initialValidate={initialValidate}
                                tableAlert={(presenter.stepTourFin === 2) ? `resumeData` : tableAlert}
                                calculatedResume={(item: any, table: any[]) => presenter.checkResume(item, status?.CodigoDimension, true, table)} 
                                checkResumePlanning={(table: any[]) => presenter.checkResumePlanning(table)}
                                gridId={`resumeData`} 
                            />
                            <MasterDataGrid 
                                id={`resumeData`}
                                dataSource={resumeTourData || finResume.data}
                                columns={columns}
                                allowCode={screen}
                                gridHelpId={`tooltip-${section}`}
                                gridHelpText={presenter.followupLabels.get("helpFinancialBudgetResume")}
                                gridTitle={presenter.followupLabels.get("financialBudgetResumeTitle")}
                                gridProps={{
                                    width: 800,
                                    scrolling:{mode: "standard" , rowRenderingMode: "standard"},
                                    editing:{ mode: "batch", allowUpdating: true, allowAdding: false, allowDeleting: false},
                                }}
                            />
                        </div>
                    :
                        <FinancialSections
                            initialValidate={initialValidate}
                            dataColumns={dataColumns}
                            status={status} 
                            screen={screen} 
                            section={section} 
                            columns={columns} 
                            saveTable={saveTable} 
                            calculateTotalRow={calculateTotalRow} 
                            sectionData={sectionData}
                            tableAlert={tableAlert}
                        />
                :
                    <FinancialExpectedResults 
                        section={section}
                        initialValidate={initialValidate}
                        dataColumns={dataColumns}
                        sectionData={sectionData} 
                        screen={screen}
                        columns={columns} 
                        saveTable={saveTable}
                        tableAlert={tableAlert}
                        status={status}
                        summary={{
                            recalculateWhileEditing: true,
                            totalItems: presenter.getFinancialSummary(section),
                            calculateCustomSummary: (options:any, i: number) => calculateTotalRow(options, columns, i)
                        }}
                        summaryData={summaryData}
                        year={projectData?.year}
                    />
            : 
                <></>
        }
        </>
    )
}

export default FollowUpFinancialDetail;


